export const FAKE_USER_ID = "66a553be-245c-401b-95bf-52cef5f71cc2";
export const FAKE_PREFERRED_USERNAME = "nathalie.wappler@srf.ch";
export const FAKE_ID_TOKEN = "fake-srg-login-bearer-for-dev";
